import { render, staticRenderFns } from "./OrganisationChildList.vue?vue&type=template&id=124f1d86&scoped=true&"
import script from "./OrganisationChildList.vue?vue&type=script&lang=js&"
export * from "./OrganisationChildList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationChildList.vue?vue&type=style&index=0&id=124f1d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f1d86",
  null
  
)

export default component.exports